import { useEffect, useState } from "react"
import PopupModal from "./popupModal"
import { Performer } from "lib/types/item/performer";
import { Popup } from "lib/types/item/popup";

export default function PopupManager({
    gender,
    currentLang,
    performer,
    popupText
}: {
    gender: string;
    currentLang: string;
    performer?: Performer;
    popupText: Popup
}): JSX.Element {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
      if (sessionStorage.getItem('popupClosed')) return;

      let firstVisit = sessionStorage.getItem('firstVisit');
      if (!firstVisit) {
          firstVisit = Date.now().toString();
          sessionStorage.setItem('firstVisit', firstVisit);
      }

      const elapsed = Date.now() - Number(firstVisit);
      const remaining = Math.max(60000 - elapsed, 0);

      const timer = setTimeout(() => {
          setShowPopup(true);
      }, remaining);

      return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
      setShowPopup(false);
      sessionStorage.setItem('popupClosed', 'true');
  };

  return (
      <>
          {showPopup && (
              <PopupModal
                  popupText={popupText}
                  onClose={handleClose}
                  gender={gender}
                  currentLang={currentLang}
                  performer={performer}
              />
          )}
      </>
  );
}